import styled from "styled-components";

export const ContainerModal = styled.div`
  box-sizing: border-box;
`;

export const TitleModal = styled.p`
  font-weight: var(--font-weight-semibold);
  font-size: 18px;
  line-height: 20px;
  color: var(--color-action-default);
  margin: 8px 0px 12px 0px;
`;
